import type { SearchableField } from "@salon/types";

export const LIMITS_SEARCH: SearchableField[] = [
  {
    id: "appointment_limits.capacity_mode",
    sectionId: "limits",
    labelKey: "search.limits.capacityMode.label",
    descriptionKey: "search.limits.capacityMode.description",
    keywordsKey: "search.limits.capacityMode.keywords",
    anchor: "field-limits-capacity-mode",
  },
  {
    id: "appointment_limits.concurrent_max",
    sectionId: "limits",
    labelKey: "search.limits.concurrentMax.label",
    descriptionKey: "search.limits.concurrentMax.description",
    keywordsKey: "search.limits.concurrentMax.keywords",
    anchor: "field-limits-concurrent-max",
  },
  {
    id: "appointment_limits.daily_max",
    sectionId: "limits",
    labelKey: "search.limits.dailyMax.label",
    descriptionKey: "search.limits.dailyMax.description",
    keywordsKey: "search.limits.dailyMax.keywords",
    anchor: "field-limits-daily-max",
  },
  {
    id: "appointment_limits.duration_aware",
    sectionId: "limits",
    labelKey: "search.limits.durationAware.label",
    descriptionKey: "search.limits.durationAware.description",
    keywordsKey: "search.limits.durationAware.keywords",
    anchor: "field-limits-duration-aware",
  },
];
